import { BulkUpload } from './bulkUpload';
import { VariantUpload } from './variantUpload';

export class BulkUploadVariants extends BulkUpload {
  Variants: VariantUpload[];
}
